// @ts-nocheck
// Hardcoded fallback map — covers the known sponge & cream products in case
// the Liquid selling_plan_groups lookup returned empty.
const KLYR_SELLING_PLANS = {
  '15295041798468': { 1: 698187252036, 2: 698187284804 }, // CONCEALING SPONGE+
  '15461492621636': { 1: 698187252036, 2: 698187284804, 4: 698401292612 }, // 3-PACK CONCEALING SPONGES+
  '15425720877380': { 1: 698187252036, 2: 698187284804 }, // 2-PACK CONCEALING SPONGE+
  '15390421909828': { 1: 698187252036, 2: 698187284804 }, // Concealing + Sponge (variants)
  '15295053496644': { 1: 698068140356, 2: 698068304196 }, // CONCEALING CREAM+
  '15509566914884': { 1: 698068140356, 2: 698068304196 }, // CONCEALING CREAM+ sub-test
  '15541733032260': { 1: 698068140356, 2: 698068304196 }  // CONCEALING CREAM+ sub-test 2
};

function getBundleState() {
  const bundleEl = document.querySelector('.maison-bundle');
  if (!bundleEl) return { subscribeOn: false, deliveryMonths: 0 };
  let subscribeOn = bundleEl.dataset.subscribeOn === 'true';
  let deliveryMonths = parseInt(bundleEl.dataset.deliveryMonths, 10);
  if ((!subscribeOn || !Number.isFinite(deliveryMonths)) && window.Alpine) {
    try {
      const data = window.Alpine.$data(bundleEl);
      if (data) {
        subscribeOn = !!data.subscribeOn;
        deliveryMonths = data.allTiers?.[data.selectedTier]?.deliveryMonths;
      }
    } catch (e) {}
  }
  return { subscribeOn, deliveryMonths };
}

function resolveSellingPlanForButton(button) {
  const { subscribeOn, deliveryMonths } = getBundleState();
  if (!subscribeOn) return null;
  const attr = `sellingPlan${deliveryMonths}m`;
  const liquidPlan = parseInt(button?.dataset[attr], 10);
  if (Number.isFinite(liquidPlan) && liquidPlan > 0) return liquidPlan;
  const fallback = KLYR_SELLING_PLANS[String(button?.dataset.productId)]?.[deliveryMonths];
  return fallback || null;
}

function applyBundleStateToButton(btn, subscribeOn, deliveryMonths) {
  if (!subscribeOn) {
    delete btn.dataset.currentSellingPlan;
    return;
  }
  const attr = `sellingPlan${deliveryMonths}m`;
  const liquidPlan = btn.dataset[attr];
  const fallback = KLYR_SELLING_PLANS[String(btn.dataset.productId)]?.[deliveryMonths];
  const plan = liquidPlan || fallback;
  if (plan) btn.dataset.currentSellingPlan = plan;
  else delete btn.dataset.currentSellingPlan;
}

function fireCartAddEvent(sourceId) {
  const e = new Event('cart:update', { bubbles: true });
  e.detail = { resource: {}, sourceId: sourceId || 'custom', data: {} };
  document.dispatchEvent(e);
}

class customOftenBought extends HTMLElement {
  constructor() {
    super();
    this.handleAddToCart = this.handleAddToCart.bind(this);
  }

  connectedCallback() {
    this.addButtons = this.querySelectorAll('[data-add-to-cart]');

    this.addButtons.forEach(addButton =>{
      addButton.addEventListener('click', (e) => this.handleAddToCart(e));
    })

    // Sync ALL plan-bearing buttons (data-add-to-cart and data-upsell-opener)
    this.planButtons = this.querySelectorAll('[data-selling-plan-1m], [data-selling-plan-2m], [data-selling-plan-4m]');

    this.onBundleState = (e) => {
      const { subscribeOn, deliveryMonths } = e.detail || {};
      this.planButtons.forEach(btn => applyBundleStateToButton(btn, subscribeOn, deliveryMonths));
    };
    document.addEventListener('maison-bundle:state', this.onBundleState);

    // Initial sync in case the bundle dispatched its event before we listened
    const bundleEl = document.querySelector('.maison-bundle');
    if (bundleEl && bundleEl.dataset.subscribeOn !== undefined) {
      const subscribeOn = bundleEl.dataset.subscribeOn === 'true';
      const months = parseInt(bundleEl.dataset.deliveryMonths, 10);
      this.planButtons.forEach(btn => applyBundleStateToButton(btn, subscribeOn, months));
    }

    // initialize tabs (inside this component)
    this.initTabs();
  }

  disconnectedCallback() {
    this.addButtons.forEach(addButton => {
      addButton.removeEventListener('click', this.handleAddToCart);
    });
    if (this.onBundleState) {
      document.removeEventListener('maison-bundle:state', this.onBundleState);
    }
  }

  /* ----------------------------------------------------------
   * TABS METHOD — works only inside this component
   * ---------------------------------------------------------- */
  initTabs() {
    const buttons = this.querySelectorAll("[data-tab-btn]");
    const panels = this.querySelectorAll("[data-tab-panel]");

    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-tab-btn");

        // deactivate all
        buttons.forEach(b => {
          b.classList.remove("active");
          b.setAttribute("aria-selected", "false");
        });
        panels.forEach(p => p.classList.remove("active"));

        // activate selected
        btn.classList.add("active");
        btn.setAttribute("aria-selected", "true");

        this.querySelector(`[data-tab-panel="${id}"]`).classList.add("active");
      });
    });
  }

  initUpsellSwiper() {
    const sliderEl = document.querySelector('.sd-product-slider');
    if (!sliderEl) return;

    // destroy old Swiper instance if exists
    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }

    new Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 4,
      scrollbar: { el: ".sd-scrollbar", draggable: true, snapOnRelease: true },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }
    });
  }

  openCartDrawer() {
    setTimeout(() => {
      document.querySelector('cart-drawer-component')?.open();
      this.initUpsellSwiper();
    }, 500);
  }

  handleAddToCart(event) {
    event.preventDefault();

    // Show loading overlay
    this.addButton = event.currentTarget;
    this.addButton?.querySelector('.loading-overlay').classList.remove('loader-hidden');
    const variantId = event.currentTarget.dataset.variantId;
    const quantity = event.currentTarget.dataset.quantity || 1;
    const sellingPlan = resolveSellingPlanForButton(event.currentTarget);
    const cartBody = { id: variantId, quantity };
    if (sellingPlan) cartBody.selling_plan = sellingPlan;
    console.log('[often-bought ATC]', { variantId, quantity, sellingPlan, bundleState: getBundleState(), buttonData: { ...event.currentTarget.dataset } });

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(cartBody)
    })
      .then(res => res.json())
      .then(data => {
        this.addButton.querySelector('.loading-overlay').classList.add('loader-hidden');
        this.addButton.querySelector('.atc-button-text').textContent = Theme.translations.added;
        fireCartAddEvent('often-bought-with');
        this.rerenderCart();
        this.emitCartUpdated();
      })
      .catch(() => {
        console.error("Failed to add item to cart.");
      })
      .finally(() => {
        setTimeout(() => {
          this.addButton.querySelector('.atc-button-text').textContent = this.addButton.querySelector('.atc-button-text').dataset.atcText;
        }, 2000);
        const drawer__dialog = document.querySelector('.cart-drawer__dialog');
        if(drawer__dialog) {
          drawer__dialog.classList.remove('cart-drawer--empty');
        }
        this.openCartDrawer();
      })
  }

  async emitCartUpdated() {
    // dispatch signal again
    const res = await fetch(`${window.Shopify.routes.root}cart.js`);
    const newCart = await res.json();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: newCart }));
  }

  rerenderCart() {
    const sectionId = document.querySelector('#header-component').dataset.sectionId;

    // dynamically fetch the cart drawer section
    fetch(`${window.Shopify.routes.root}?sections=${sectionId}`)
      .then(response => response.json())
      .then(data => {
        const cartDrawerInner = document.querySelector('.cart-drawer__inner');
        if (!cartDrawerInner) {
          return;
        }

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data[sectionId];

        const newContent = tempDiv.querySelector('.cart-drawer__inner');
        if (!newContent) {
          return;
        }

        cartDrawerInner.innerHTML = newContent.innerHTML;
      })
      .catch(() => {
        console.error("Failed to update cart drawer.");
      });
  }
}

if (!customElements.get('custom-often-bought')) {
  customElements.define('custom-often-bought', customOftenBought);
}
